(<template>
  <div id="app">
    <router-view></router-view>
    <tourguide-navbar></tourguide-navbar>
    <tourguide-footer></tourguide-footer>
  </div>
</template>)

(<script>
import axios from 'axios'
import TourGuideNavbar from './components/Tourguide-Navbar.vue'
import TourGuideFooter from './components/Tourguide-Footer.vue'

export default {
  name: 'app',
  components: {
    'tourguide-navbar': TourGuideNavbar,
    'tourguide-footer': TourGuideFooter
  },
  created () {
    if (this.$localStorage.get('language')) {
      this.$language.current = this.$localStorage.get('language')
    } else {
      this.$localStorage.set('language', this.$language.current)
    }
    this.checkLogIn()
  },
  methods: {
    checkLogIn () {
      axios({
        method: 'get',
        url: `${process.env.SERVER_URL}/auth/isLoggedIn`,
        withCredentials: true
      })
      .then(response => {
        if (!this.$session.exists()) {
          this.$session.set('id', response.data.id)
          this.$session.set('username', response.data.username)
          this.$session.set('email', response.data.email)
          this.$session.set('role', response.data.role)
          this.$router.push('/monuments/list')
        }
      })
      .catch(() => {
        if (this.$session.exists()) {
          this.$session.destroy()
          window.location = '/'
        }
      })
    }
  }
}
</script>)

(<style>
html,
body {
	margin: 0;
	padding: 0;
	height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100%;
	position: relative;
}
.form {
  padding-top: 6em;
  padding-bottom: 6em;
  margin: auto;
  width: 40%;
}
.list {
  padding-top: 6em;
  padding-bottom: 6em;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
@media screen and (max-width: 900px) {
  .form {
    width: 55%;
  }
  .list {
    width: 90%;
    padding-bottom: 1em;
  }
}
@media screen and (min-width: 900px) and (max-width: 1200px) {
  .form {
    width: 70%;
  }
  .list {
    width: 90%;
    padding-bottom: 1em;
  }
}
</style>)



// WEBPACK FOOTER //
// src/App.vue